import { LoyaltyApi } from "@jti/rest-api";
import { type CampaignOrderData, type GetEligibleCampaignsResponseType } from "@jti/rest-api-types";

import { TAGS } from "../common/tags";
import type { LoyaltyApiBuilder } from "../loyaltyApi.types";

export type GetLoyaltyVouchersEndpointArgs = CampaignOrderData & { uuid: string; ciam_token?: string };
export type GetLoyaltyVouchersEndpointResponse = GetEligibleCampaignsResponseType[];

export const getLoyaltyVouchersEndpoint = (builder: LoyaltyApiBuilder) => ({
  getLoyaltyVouchers: builder.query<GetLoyaltyVouchersEndpointResponse, GetLoyaltyVouchersEndpointArgs>({
    queryFn: async ({ uuid, ciam_token, ...campaignData }) => {
      const loyaltyApi = LoyaltyApi.init();
      const data = await loyaltyApi.getEligibleCampaigns(uuid, ciam_token ?? "", campaignData);

      return { data };
    },
    providesTags: [TAGS.LOYALTY_VOUCHERS],
  }),
});
